import { thinScrollbarGutterWidth } from '@modules/layout/layout/constants/layoutConstants';
import { makeStyles } from '@rbx/ui';
import styles from '../utils/styles';

export const sidebarWidth = 300;

const CREATOR_HUB_SIDEBAR_PADDING = 24;

export const showLeftNavMinBreakpoint = 'Large';

const useSideBarNavigationStyles = makeStyles()((theme) => ({
  drawerOpen: {
    width: sidebarWidth - thinScrollbarGutterWidth,
    borderRight: `solid 1px ${theme.palette.components.divider}`,
    overflowY: 'auto',
  },

  drawerClosed: {
    padding: '16px 12px',
    minWidth: '48px',
    '&:hover': {
      backgroundColor: theme.palette.states.hover,
    },
  },

  toggle: {
    position: 'absolute',
    top: 0,
    right: 0,
    padding: '8px',
  },

  toggleClosed: {
    right: 'initial',
    left: 0,
    padding: '16px 12px',
    height: '100%',
    cursor: 'pointer',
    '&:hover > button': {
      backgroundColor: theme.palette.states.hover,
    },
  },

  navigationHeading: {
    marginBottom: '12px',
  },

  sidebarContent: {
    padding: CREATOR_HUB_SIDEBAR_PADDING,
    paddingRight: CREATOR_HUB_SIDEBAR_PADDING - thinScrollbarGutterWidth,
    paddingBottom: '64px',
    flexDirection: 'column',
    fontSize: '14px',
    ...styles.wordBreakWrap,
    maxWidth: '100%',
    width: '100%',
  },

  iaSidebarContent: {
    padding: 0,
    paddingRight: 0,
    paddingBottom: 0,
  },

  stickySidebarContent: {
    position: 'sticky',
    top: 0,
    left: 0,
    width: '100%',
    zIndex: 2,
    backgroundColor: theme.palette.navigation.default,
    [theme.breakpoints.down(showLeftNavMinBreakpoint)]: {
      backgroundColor: 'initial',
    },
  },
  iaStickySidebarContent: {
    backgroundColor: theme.palette.navigation.default,
    top: '-16px',
  },

  docked: {
    position: 'relative',
    height: '100%',
    // FIXME: temporary solution while z-index treatment is being discussed
    zIndex: theme.zIndex.appBar - 1,
  },

  navigationBackground: {
    background: theme.palette.navigation.default,
  },

  paper: {
    position: 'relative',
    borderRight: `none`,
    [theme.breakpoints.down(showLeftNavMinBreakpoint)]: {
      display: 'none',
    },
  },
}));

export default useSideBarNavigationStyles;
